export default "__VITE_ASSET__gYwl6uzt__"